import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { AppState } from '~/reducers';
import { applyAnalyticsConsent } from '../utils/consent-utils';
import { applyClarityConsent } from '../utils/clarity-consent';
import {
  acceptAll as acceptAllAction,
  rejectNonEssential as rejectNonEssentialAction,
} from '../store/cookie-consent-slice';

const useFleetCookies = () => {
  const dispatch = useDispatch();
  const consentState = useSelector((state: AppState) => state.cookieConsent);

  const acceptAll = useCallback(() => {
    applyAnalyticsConsent(true);
    applyClarityConsent(true);
    dispatch(acceptAllAction());
  }, [dispatch]);

  const rejectNonEssential = useCallback(() => {
    applyAnalyticsConsent(false);
    applyClarityConsent(false);
    dispatch(rejectNonEssentialAction());
  }, [dispatch]);

  const togglePerformanceCookies = useCallback(
    (accepted: boolean) => {
      if (accepted) {
        acceptAll();
      } else {
        rejectNonEssential();
      }
    },
    [acceptAll, rejectNonEssential]
  );

  return {
    isPerformanceCookiesAccepted: consentState.acceptedCookies,
    acceptedCookies: consentState.acceptedCookies,
    showCookieBanner: consentState.showCookieBanner,
    consentDate: consentState.consentDate,
    acceptAll,
    rejectNonEssential,
    togglePerformanceCookies,
  };
};

export default useFleetCookies;
